import React from "react";
import { useTranslation } from "react-i18next";
import servicesData from "../data/servicesData";
import ourProcessData from "../data/ourProcessData";

export default function Services() {
  const { t } = useTranslation();

  const showProcess = ourProcessData.map((el, index) => (
    <div key={index} className="w-100 w-[28%] flex flex-col items-center justify-between text-center">
      <div className="w-12 h-12 bg-[#3896BE] rounded-full flex items-center justify-center text-white font-bold">
        {el.id}
      </div>
      <div className="mt-4">
        <div className="text-xl font-semibold text-[#3896BE]">
          {t(el.title)}
        </div>
        <p className="text-sm text-gray-600 mt-2">{t(el.details)}</p>
      </div>
      <div className="w-full h-1 bg-[#3896BE]/20 mt-6"></div>
    </div>
  ));

  const showData = servicesData.map((el, index) => {
    return (
      <div
        key={index}
        className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col gap-[20px] border border-[#3896BE]/20 hover:border-[#3896BE]"
      >
        <div className="mb-4">
          <img
            src={el.icon}
            alt={el.title}
            className="w-16 h-16 object-contain"
          />
        </div>
        <div className="mb-3">
          <div className="text-xl font-semibold text-[#3896BE]">
            {t(el.title)}
          </div>
          <p className="text-sm text-gray-600 leading-relaxed mt-2">
            {t(el.details)}
          </p>
        </div>
        <ul className="flex flex-col gap-[8px] text-sm text-gray-700">
          {el.points.map((point, pointIndex) => (
            <li key={pointIndex} className="flex items-center gap-2">
              <img
                src={require("../../assets/icons/check-box.svg").default}
                alt="Check"
                className="w-5 h-5"
              />
              <span>{t(point)}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  });

  return (
    <>
      <section className="services-landing relative py-[40px]">
        <div className="container h-full relative z-10 text-white flex flex-col items-center justify-center gap-[6px]">
          <div className="text-[50px] font-bold text-white">
            {t("Our Services")}
          </div>
          <div className="text-[20px] w-full md:w-1/2 text-center text-white">
            {t(
              "Comprehensive financial and business advisory services tailored to help your business thrive in today's competitive market"
            )}
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container flex flex-col gap-[30px]">
          <div className="flex flex-col items-center justify-center gap-[8px] text-center mb-12">
            <h2 className="text-[35px] font-bold text-[#3896BE]">
              {t("Complete Financial Solutions")}
            </h2>
            <p className="text-lg text-[#404040] mx-auto max-w-[800px]">
              {t(
                "From audit and tax to strategic advisory, we provide comprehensive services to support every aspect of your business's financial needs."
              )}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {showData}
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container flex flex-col gap-[30px]">
          <div className="flex flex-col items-center justify-center gap-[8px] text-center mb-12">
            <h2 className="text-[35px] font-bold text-[#3896BE]">
              {t("Our Process")}
            </h2>
            <p className="text-lg text-[#404040] mx-auto max-w-[800px]">
              {t(
                "A systematic approach to delivering exceptional results for every client engagement"
              )}
            </p>
          </div>

          <div className="f-col flex flex-wrap justify-center gap-6">{showProcess}</div>
        </div>
      </section>
    </>
  );
}
